import React from "react";
import { observer } from "mobx-react";
import { CircularProgress, Box } from "@mui/material";
import useStore from "../../../../helpers/useStore";
import { PatientsContext } from "../../../../stores/Patients/patients.provider";
import TerminView from "../TerminView";
import { TerminViewConstants } from "../../TerminView";
import { useAppointmentsBySeries } from "../../../../stores/Appointment/appointment.queries";

interface SeriesTerminViewProps {
  seriesId?: string;
  patientId?: number;
}

const SeriesTerminView: React.FC<SeriesTerminViewProps> = observer(
  ({ seriesId: propSeriesId, patientId: propPatientId }) => {
    const patientsStore = useStore(PatientsContext);

    // Use props if provided, otherwise get from store
    const seriesId = propSeriesId || patientsStore.selectedSeriesId;
    const patientId = propPatientId || patientsStore.selectedPatientId;

    const { data: appointments = [], isLoading, error } = useAppointmentsBySeries(seriesId || "");

    // console.debug(
      // "SeriesTerminView Rendered with seriesId:",
      // seriesId,
      // "patientId:",
      // patientId,
      // "and appointments:",
      // appointments
    // );

    if (!seriesId) {
      return (
        <Box p={2}>
          <span>Kein Serien ausgewählt</span>
        </Box>
      );
    }

    if (isLoading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress />
        </Box>
      );
    }

    if (error) {
      return (
        <Box p={2}>
          <span>Fehler beim Laden der Termine für Serien {seriesId}</span>
        </Box>
      );
    }

    return (
      <TerminView
        appointments={appointments}
        patientId={patientId}
        appointmentsLoading={isLoading}
        isView={TerminViewConstants.SERIES_VIEW}
      />
    );
  }
);

export default SeriesTerminView;
